// extracted by mini-css-extract-plugin
module.exports = {"toBeCenter":"VideoPlayer_toBeCenter__Tho8E","videoPlayer":"VideoPlayer_videoPlayer__n1rSc"};